var _path, _path2, _path3, _path4, _path5;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function Svg5({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    t: 1766389674544,
    className: "icon",
    viewBox: "0 0 1024 1024",
    xmlns: "http://www.w3.org/2000/svg",
    "p-id": 12933,
    width: 22,
    height: 22,
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M659.968 512.512c19.968 0 36.352-16.384 36.352-36.352 0-19.968-16.384-36.352-36.352-36.352h-111.104v-1.536L684.544 296.96c13.824-14.848 13.824-37.888-1.024-51.712-14.336-13.824-37.376-13.312-51.712 1.024l-116.224 121.856-122.88-122.368c-14.336-14.336-37.376-14.336-51.712 0s-14.848 37.376-0.512 51.712l135.168 135.68v6.656H367.616c-19.968 0-36.352 16.384-36.352 36.352 0 19.968 16.384 36.352 36.352 36.352h108.032v73.216H367.616c-19.968 0-36.352 16.384-36.352 36.352s16.384 36.352 36.352 36.352h108.032v108.544c0 19.968 16.384 36.352 36.352 36.352 19.968 0 36.352-16.384 36.352-36.352v-108.544h111.104c19.968 0 36.352-16.384 36.352-36.352s-16.384-36.352-36.352-36.352h-111.104v-73.216h111.616z m327.168-303.616h-269.312c-20.48 0-36.864-16.384-36.864-36.864s16.384-36.864 36.864-36.864h269.312c20.48 0 36.864 16.384 36.864 36.864 0 19.968-16.384 36.864-36.864 36.864z",
    "p-id": 12934
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M816.128 305.664V36.864c0-20.48 16.384-36.864 36.864-36.864s36.864 16.384 36.864 36.864v269.312c0 20.48-16.384 36.864-36.864 36.864-20.48-0.512-36.864-16.896-36.864-37.376z",
    "p-id": 12935
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M512 1024C229.888 1024 0 794.112 0 512S229.888 0 512 0v76.8c-240.128 0-435.2 195.072-435.2 435.2s195.072 435.2 435.2 435.2 435.2-195.072 435.2-435.2h76.8c0 282.112-229.888 512-512 512z",
    "p-id": 12936
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M985.6 512m-38.4 0a38.4 38.4 0 1 0 76.8 0 38.4 38.4 0 1 0-76.8 0Z",
    "p-id": 12937
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M512 38.4m-38.4 0a38.4 38.4 0 1 0 76.8 0 38.4 38.4 0 1 0-76.8 0Z",
    "p-id": 12938
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(Svg5);
export default __webpack_public_path__ + "static/media/5.36af3d748f4fc1224eb27efbc19c0f89.svg";
export { ForwardRef as ReactComponent };